import NavigationBar from "../NavBar/NavigationBar";

const Header = (props) => {
  return <NavigationBar></NavigationBar>;
};
export default Header;
